import Schema from '@/schema/Schema';
import * as yup from 'yup';

export const EditMsgSchema = Schema.object().shape({
    msg: yup.string()
});
